import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Button,
} from "@mui/material";
import PingButton from "./ping-button";
import RebootButton from "./reboot-button";
import StreamButton from "./stream-button";
import { useMovementLoadListAction } from "../movements/movements-load-list";
import { useOnlineDeviceIds } from "./online-device-provider";
import { useTranslation } from "react-i18next";
import { useReactionLoadListAction } from "../reactions/reactions-load-list";
import { useWaitUntilJobsFinished } from "../../../devices";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useSensorLoadListAction } from "../sensors/sensors-load-list";

export default function OnlineDeviceActionsCard({ ...props }) {
  const { t } = useTranslation();
  const { serialNumber } = useOnlineDeviceIds();
  const loadMovements = useMovementLoadListAction(serialNumber);
  const loadReactions = useReactionLoadListAction(serialNumber);
  const loadSensors = useSensorLoadListAction(serialNumber);
  const waitUntilJobsFinished = useWaitUntilJobsFinished();

  const handleLoadConfiguration = async () => {
    await loadReactions();
    await waitUntilJobsFinished();
    await loadMovements();
    await waitUntilJobsFinished();
    await loadSensors();
  };

  return (
    <Card {...props}>
      <CardHeader title={`Actions`} />
      <CardContent>
        <Stack spacing={2}>
          <Button
            startIcon={<RefreshIcon />}
            variant="contained"
            fullWidth
            onClick={handleLoadConfiguration}
          >
            {t("DEVICES.DETAILS.TASKS_CARD.LOAD_CONFIGURATION")}
          </Button>
          <StreamButton />
          <RebootButton />
          <PingButton />
        </Stack>
      </CardContent>
    </Card>
  );
}

OnlineDeviceActionsCard.propTypes = {};
